export const replaceTextKeyByVariablesOfUrl = ({ replacements, url }) => {
  let modifiedURL = url
  replacements.forEach(([key, value]) => {
    modifiedURL = modifiedURL.replace(key, value)
  })
  return modifiedURL
}
